export enum UrlIdKey {
  Client = "memberClientId",
  Collaborator = "collaboratorId",
  CollaboratorV2 = "memberId",
  Year = "year"
}
